import script from "./AttendancesCalendar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AttendancesCalendar.vue?vue&type=script&lang=ts&setup=true"

import "./AttendancesCalendar.vue?vue&type=style&index=0&id=6e8ac30e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8ac30e"]])

export default __exports__